module.exports = [{"type":"hash","text":"頻率限制"},{"type":"html","text":"如果請求過於頻繁系統將自動限制請求，5分鐘後，會自動恢復；"},{"type":"html","text":"基於賬號UID的限頻,每個接口的都有自己獨立的限頻，相互不影響"},{"type":"html","text":"使用者可依據Http Header中的\"X-RateLimit-Requests-Remain\"（限頻剩餘次數）及\"X-RateLimit-Requests-Expire\"（視窗過期時間）查看目前限頻使用情況，以及所在時間視窗的過期時間，根據該數值動態調整您的請求頻率。"},{"type":"html","text":"<h4>REST API</h4>"},{"type":"html","text":"同時會受到根據UID和IP的不同限頻，基於UID限頻詳見各接口文檔，其中基於IP限頻會基於以下分組規則進行"},{"type":"html","text":"<li>行情接口基於IP限頻總: 500/10s</li>"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/basic/04_rate_limits.json
// module id = XvOK
// module chunks = 3